// services/cuponService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'cupones/';

// En tu archivo de tipos (ej: types.ts)
export interface Cupon {
    id: number;
    codigo: string;
    descripcion: string;
    descuento_monto: number | null;
    descuento_porcentaje: number | null;
    fecha_inicio: string;
    fecha_fin: string;
    fecha_creacion: string;
    uso_unico_por_cliente: boolean;
    plan_aplicable_id: number | null; // Campo para enviar al backend
    plan_aplicable?: { // Campo opcional para respuesta del backend
        id: number;
        plan_nombre: string;
        servicio_nombre: string;
    } | null;
}


// GET: Obtener todos los cupones
export const fetchCupones = async (): Promise<Cupon[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Cupon[]>(API_URL);
        return response.data;
    });
};

// POST: Crear un nuevo cupón
export const createCupon = async (data: Omit<Cupon, 'id' | 'fecha_creacion' | 'plan_aplicable'>) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};
// PUT: Actualizar un cupón existente
export const updateCupon = async (id: number, data: Partial<Omit<Cupon, 'id' | 'fecha_creacion'>>) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar un cupón
export const deleteCupon = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
